import { render, staticRenderFns } from "./_wify.vue?vue&type=template&id=338bcb6d&lang=pug&"
import script from "./_wify.vue?vue&type=script&lang=js&"
export * from "./_wify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports